//
// Copyright (c) 2018 Nutanix Inc. All rights reserved.
//
// AppNavBar - Main navigation bar containing app navigation components.
//

// Libs
import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouteLink } from 'react-router-dom';

// Components
import {
    Dropdown,
    Menu,
    MenuController,
    MenuItem,
    NavBarLayout,
    NutanixLogoIcon,
} from '@nutanix-ui/prism-reactjs';

// LESS
import './AppNavBar.less';

import { PATH_URL } from '../../constant';

// ---------
// AppNavBar
// ---------

class AppNavBar extends React.Component {
    /**
     * Click event handler for the user Dropdown menu.
     * @param {Object} params - Click event parameters.
     * @param {Event}  params.event - DOM click event.
     * @param {Object} params.item - Params of the item that was clicked.
     * @param {String} params.key - Item key.
     * @param {String} params.keyPath - keyPath to item.
     * @param {Array}  params.openKeyMap - Array of open keys.
     * @param {String} params.type - Item type (e.g. 'collapsible-header').
     * @returns {void}
     */
    handleClickMenu = ({ key }) => {
        switch (key) {
            case 'logout':
                this.props.handleClickLogout();
                break;
            default:
            // Do nothing.
        }
    };

    /**
     * Renders the selected scope based on the selected filters
     * @param {Array} filtersSchema - array of FilterPropTypes
     * @param {Object} filtersValues - filters values map
     * @returns {Component} - list of the selected filters
     */
    render() {
        const { handleClickMenu, handleClickLogout, isAuthenticated, leftPanelVisible, username } =
            this.props;

        const logoIcon = (
            <RouteLink to={PATH_URL.DEFAULT}>
                <NutanixLogoIcon color="dark" />
            </RouteLink>
        ); // to="/"

        let accountInfo = null;
        if (!isAuthenticated) {
            const dropDownMenu = (
                <Menu
                    className="AppNavBar-accountInfo-menu"
                    theme="dark"
                    onClick={this.handleClickMenu}
                >
                    <MenuItem key="authn-docs">
                        <a className="iam-headermenu-item" target="authn-docs" href="/docs">
                            Launch AuthN API Docs
                        </a>
                    </MenuItem>
                    <MenuItem key="logout">
                        <RouteLink
                            onClick={handleClickLogout}
                            className="iam-headermenu-item"
                            to={PATH_URL.FORGETLOGIN}
                        >
                            {'Logout'}
                        </RouteLink>
                    </MenuItem>
                </Menu>
            );
            accountInfo = (
                <Dropdown
                    className="AppNavBar-accountInfo"
                    popup={dropDownMenu}
                    getPopupContainer={() => document.querySelector('.Iam')}
                >
                    {username}
                </Dropdown>
            );
        }

        return (
            <NavBarLayout
                menuIcon={<MenuController open={leftPanelVisible} onClick={handleClickMenu} />}
                title="IAM UI"
                logoIcon={logoIcon}
                accountInfo={accountInfo}
            />
        );
    }
}

AppNavBar.propTypes = {
    handleClickLogout: PropTypes.func,
    handleClickMenu: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    leftPanelVisible: PropTypes.bool,
    username: PropTypes.string,
};

export default AppNavBar;
